'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _product = require('../actions/product');

var _utils = require('../utils');

var _constants = require('../constants');

var _product_list = require('../components/product_list');

var _product_list2 = _interopRequireDefault(_product_list);

var _product_filter = require('../components/product_filter');

var _product_filter2 = _interopRequireDefault(_product_filter);

var _with_product_type = require('../hocs/with_product_type');

var _with_product_type2 = _interopRequireDefault(_with_product_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Products = _react2.default.createClass({
    displayName: 'Products',

    propTypes: {
        products: _react.PropTypes.object.isRequired,
        filter: _react.PropTypes.object.isRequired,
        dispatch: _react.PropTypes.func.isRequired
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (!(0, _utils.filterEqual)(nextProps.filter, this.props.filter)) {
            var dispatch = nextProps.dispatch,
                filter = nextProps.filter;

            dispatch((0, _product.fetchProductsIfNeeded)(filter));
        }
    },
    componentDidMount: function componentDidMount() {
        var _props = this.props,
            dispatch = _props.dispatch,
            filter = _props.filter;

        dispatch((0, _product.fetchProductsIfNeeded)(filter));
    },
    onChange: function onChange(name, value) {

        this.props.dispatch((0, _product.filterProducts)(_defineProperty({}, name, value)));
    },
    handleStatusChange: function handleStatusChange(id, oldStatus) {
        var _props2 = this.props,
            dispatch = _props2.dispatch,
            filter = _props2.filter,
            router = _props2.router;

        var status = oldStatus === 1 ? 0 : 1;
        dispatch((0, _product.postProductIfNeeded)({ id: id, status: status }, router));
    },
    onPageChange: function onPageChange(page) {
        // 页码改变
        var _props3 = this.props,
            dispatch = _props3.dispatch,
            filter = _props3.filter;

        dispatch((0, _product.fetchProductsIfNeeded)(filter, page));
    },
    render: function render() {
        var _props4 = this.props,
            productTypes = _props4.productTypes,
            filter = _props4.filter;

        return _react2.default.createElement(
            'div',
            { id: 'products', className: 'clearfix' },
            _react2.default.createElement(
                _button2.default,
                { type: 'primary', className: 'create' },
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/products/create' },
                    '\u521B\u5EFA\u5546\u54C1'
                )
            ),
            _react2.default.createElement(_product_filter2.default, { status: _constants.PRODUCT_STATUS, types: productTypes, onChange: this.onChange, filter: filter }),
            _react2.default.createElement(_product_list2.default, { products: this.props.products, handleStatusChange: this.handleStatusChange, onChange: this.onPageChange })
        );
    }
});

var mapStateToProps = function mapStateToProps(store) {
    var _store$product = store.product,
        products = _store$product.products,
        filter = _store$product.filter;
    var productTypes = store.productType.productTypes;

    return {
        products: products,
        filter: filter,
        productTypes: productTypes.items
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _with_product_type2.default)(Products));


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/products.js
// module id = 1477
// module chunks = 0